declare global {
	interface Window {
		dataLayer: any[]
		gtag: (...args: any[]) => void
	}
}

// Initialize dataLayer and placeholder gtag
export function initDataLayer() {
	window.dataLayer = window.dataLayer || []

	// Only define gtag if it doesn't exist
	if (!window.gtag) {
		window.gtag = function () {
			window.dataLayer.push(arguments)
		}
	}
}
// Grant analytics consent and load GA
export function grantAnalytics() {
	if (!window.gtag) initDataLayer() // safety check
	window.gtag("consent", "update", { analytics_storage: "granted" })

	// Load GA script dynamically if not loaded
	// @todo we have to replace with the ga tag id below
	if (!document.querySelector('script[src*="gtag/js"]')) {
		const script = document.createElement("script")
		script.src = "https://www.googletagmanager.com/gtag/js?id=G-CHWSH6RQ36"
		script.async = true
		document.head.appendChild(script)

		script.onload = () => {
			window.gtag("js", new Date())
			window.gtag("config", "G-CHWSH6RQ36")
		}
	}
}

export function denyAnalytics() {
	if (!window.gtag) initDataLayer() // safety check
	window.gtag("consent", "update", { analytics_storage: "denied" })
	removeAnalyticsCookies()
}

// Remove first-party GA cookies on your domain
export function removeAnalyticsCookies() {
	document.cookie.split(";").forEach((cookie) => {
		const name = cookie.split("=")[0].trim()
		if (name.startsWith("_ga") || name.startsWith("_gid")) {
			document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.valormovies.com`
		}
	})
}
